"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var serverUrl = undefined;
function setServerUrl(key) {
  serverUrl = key;
}
function getServerUrl() {
  return serverUrl;
}
var token = undefined;
function setToken(key) {
  token = key;
}
function getToken() {
  return token;
}
var env = undefined;
function setEnv(envVar) {
  env = envVar;
}
function getEnv() {
  return env;
}
var stripePublic = undefined;
function setStripeKey(key) {
  stripePublic = key;
}
function getStripeKey() {
  return stripePublic;
}
var stripeDonationPublic = undefined;
function setStripeDonationKey(key) {
  stripeDonationPublic = key;
}
function getStripeDonationKey() {
  return stripeDonationPublic;
}
var disableTrack = false;
function setDisableTrack(key) {
  disableTrack = key;
}
function getDisableTrack() {
  return disableTrack;
}
var applicationId = undefined;
function setApplicationId(key) {
  applicationId = key;
}
function getApplicationId() {
  return applicationId;
}
var restApiKey = undefined;
function setRestApiKey(key) {
  restApiKey = key;
}
function getRestApiKey() {
  return restApiKey;
}
var utmData = undefined;
function setUtmData(key) {
  utmData = key;
}
function getUtmData() {
  return utmData;
}
exports.default = {
  setServerUrl,
  getServerUrl,
  setToken,
  getToken,
  setEnv,
  getEnv,
  setStripeKey,
  getStripeKey,
  setStripeDonationKey,
  getStripeDonationKey,
  getDisableTrack,
  setDisableTrack,
  setApplicationId,
  getApplicationId,
  setRestApiKey,
  getRestApiKey,
  setUtmData,
  getUtmData
};